type UrlKeysType = {
  register_invite_token: 'invite_token';
  token: 'token';
  email: 'email';
  adc_logout: 'adc_logout';
  cid: 'cid';
  promohub_plan_id: 'promohub_plan_id';
};

export const URL_KEY: UrlKeysType = {
  register_invite_token: 'invite_token',
  token: 'token',
  email: 'email',
  adc_logout: 'adc_logout',
  cid: 'cid',
  promohub_plan_id: 'promohub_plan_id',
};
